import React from 'react';

const Dashboard = () => {
    return (
        <>
            <div className='duration-500 max-w-screen-2xl justify-center mx-auto'>
                <div className='md:h-32 mt-16 md:mt-5 shadow-2xl'>
                    <img className='duration-500 w-full md:h-[30rem] px-3 md:px-0 rounded-xl' src='./free.jpg' alt='images'/>
                </div>
                <div className='md:px-16 mx-auto justify-center overflow-hidden px-5 md:text-center md:pt-0 pt-10'>
                    <div className='md:py-16'>
                        <div className='md:text-center mx-auto max-w-screen-md'>
                            <h1 className='second xl:text-6xl lg:text-5xl text-3xl md:text-5xl items-center duration-300 text-[#136690] md:text-white'>
                                Schedule a Free Consultation
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Dashboard;